/* eslint-disable @typescript-eslint/no-explicit-any */
import { action, payload } from "ts-action";
import {
  BulkX2yResponse,
  X2yItem,
  X2yResponse,
} from "../../requests/x2y/types";
import { X2yController } from "./types";
import { createActionTypeString } from "./actionTypes";

export const getX2yRequest = action(
  createActionTypeString("get", "request"),
  payload<{ controller: X2yController; xId: number }>()
);
export const getX2yReceive = action(
  createActionTypeString("get", "receive"),
  payload<{
    controller: X2yController;
    xId: number;
    selected: X2yItem[];
    unselected: X2yItem[];
  }>()
);
export const getX2yError = action(
  createActionTypeString("get", "error"),
  payload<{ controller: X2yController; xId: number; error: any }>()
);

export const updateX2yRequest = action(
  createActionTypeString("update", "request"),
  payload<{ controller: X2yController; xId: number; payload: X2yResponse }>()
);
export const updateX2yReceive = action(
  createActionTypeString("update", "receive"),
  payload<{
    controller: X2yController;
    xId: number;
    selected: X2yItem[];
    unselected: X2yItem[];
  }>()
);
export const updateX2yError = action(
  createActionTypeString("update", "error"),
  payload<{ controller: X2yController; xId: number; error: any }>()
);

export const bulkGetX2yRequest = action(
  createActionTypeString("getBulk", "request"),
  payload<{ controller: X2yController; xIds: number[] }>()
);
export const bulkGetX2yReceive = action(
  createActionTypeString("getBulk", "receive"),
  payload<{
    controller: X2yController;
    xIds: number[];
    x2ys: BulkX2yResponse;
  }>()
);
export const bulkGetX2yError = action(
  createActionTypeString("getBulk", "error"),
  payload<{ controller: X2yController; xIds: number[]; error: any }>()
);

export const bulkUpdateX2yRequest = action(
  createActionTypeString("updateBulk", "request"),
  payload<{
    controller: X2yController;
    xIds: number[];
    payload: BulkX2yResponse;
  }>()
);
export const bulkUpdateX2yReceive = action(
  createActionTypeString("updateBulk", "receive"),
  payload<{
    controller: X2yController;
    xIds: number[];
    x2ys: BulkX2yResponse;
  }>()
);
export const bulkUpdateX2yError = action(
  createActionTypeString("updateBulk", "error"),
  payload<{ controller: X2yController; xIds: number[]; error: any }>()
);
